import axios from "axios";
import { Profile, User } from "src/types/user";
import { axiosErrorUnwrap } from "src/utils/axiosError";

/**
 * register retail user
 * @returns user details
 */
export const createUser = async () => {
  try {
    const res = await axios.post<any>("/api/retail/users", {});
    return res.data;
  } catch (error) {
    const errorUnwrap = axiosErrorUnwrap(error);
    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
  }
};

/**
 * update user
 * @returns user details
 */
export const updateUser = async (payload: Profile): Promise<User> => {
  try {
    const res = await axios.put<any>("/api/retail/users", payload);
    return res.data;
  } catch (error) {
    const errorUnwrap = axiosErrorUnwrap(error);
    throw Object.assign(new Error(errorUnwrap.message), errorUnwrap);
  }
};
